import {Box, ButtonBase, Collapse, Stack, Typography} from '@mui/material';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useServicePointHours} from './hooks/useServicePointHours';
import {ServicePointHoursProps} from './types';

const {at} = translations['pt-br'].commons;
const {expandHours, collapseHours} = translations['pt-br'].privateFlow.help.ourAddresses;

export function ServicePointHours({hours}: ServicePointHoursProps) {
	const {
		theme,
		expandedState,
		handleExpandClick,
		statusLabel,
		statusColor,
		currentHour,
		statusDetail,
	} = useServicePointHours({hours});

	return (
		<Stack gap={expandedState ? 1 : 0} maxWidth={'350px'}>
			<Stack
				component={ButtonBase}
				type="button"
				disableRipple
				direction="row"
				gap={1}
				onClick={handleExpandClick}
				aria-label={expandedState ? collapseHours : expandHours}>
				<Icon name="query-builder-filled" size={24} color={theme.palette.primary.main} />
				<Box display="flex" alignItems="center" gap={0.75} flexGrow={1}>
					<Typography variant="body1" fontWeight={600} color={statusColor}>
						{statusLabel}
					</Typography>
					{statusDetail ? (
						<Typography variant="body1" color="text.secondary">
							· {statusDetail}
						</Typography>
					) : null}
				</Box>

				<Icon
					name={expandedState ? 'expand-less-filled' : 'expand-more-filled'}
					color={theme.palette.primary.main}
				/>
			</Stack>

			<Collapse in={expandedState}>
				<Stack gap={1} pl={3.75} pr={0.5}>
					{hours.map(hour => {
						const isCurrentDay = hour === currentHour;

						return (
							<Stack
								key={hour.dia}
								direction="row"
								justifyContent="space-between"
								gap={2}>
								<Typography
									variant="body1"
									color={isCurrentDay ? 'text.primary' : 'text.secondary'}
									fontWeight={isCurrentDay ? 600 : 400}>
									{hour.dia}
								</Typography>
								<Typography
									variant="body1"
									fontWeight={isCurrentDay ? 600 : 400}
									whiteSpace="nowrap">
									{hour.abertura} {at} {hour.fechamento}
								</Typography>
							</Stack>
						);
					})}
				</Stack>
			</Collapse>
		</Stack>
	);
}
